import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TokenService } from '../../auth/token.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface EventPayload {
    phone: string;
    event_type: string;
    event_data: Record<string, any>;
    idempotency_key?: string;
}

export interface EventResult {
    status: string;
    eventId?: string;
    message?: string;
}

@Injectable({ providedIn: 'root' })
export class EventSetupService {

    constructor(private tokenService: TokenService, private http: HttpClient) {}

    private get cid(): string {
        return this.tokenService.getCompanyId() ?? '';
    }

    send(payload: EventPayload, testMode: boolean): Observable<EventResult> {
        const url = testMode
            ? `${environment.eventApiBaseUrl}/event/v1/test/${this.cid}`
            : `${environment.eventApiBaseUrl}/event/v1/${this.cid}`;
        return this.http.post<EventResult>(url, payload);
    }
}
